var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height-container",attrs:{"id":"login-page","data-component":"login"}},[(!_vm.isLoggedIn)?_c('login-layout',[(!_vm.isKMOffline)?_c('login-form-online'):_c('login-form-offline')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }